import { render } from "./SelectWrapper.vue?vue&type=template&id=a437dff8&scoped=true"
import script from "./SelectWrapper.vue?vue&type=script&lang=js"
export * from "./SelectWrapper.vue?vue&type=script&lang=js"

import "./SelectWrapper.vue?vue&type=style&index=0&id=a437dff8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a437dff8"]])

export default __exports__